<template>
  <v-form
    v-model="valid"
    ref="form"
  >
    <v-text-field
      v-model="name"
      label="Tracking Name"
      hint="Choose how it will be displayed in Tracking list"
      persistent-hint
      :rules="fieldRules"
      required
    ></v-text-field>

    <v-select
      v-model="data.should"
      label="Tracked keywords"
      hint="Add keywords or phrases for tracking"
      persistent-hint
      :rules="fieldRules"
      required
      append-icon=""
      chips
      deletable-chips
      tags
      ref="keywordInput"
    ></v-select>

    <v-select
      v-model="data.must_not"
      label="Exclude"
      hint="Add keywords or phrases to be excluded"
      persistent-hint
      append-icon=""
      chips
      deletable-chips
      tags
    ></v-select>

    <v-btn
      color="primary"
      @click="submit"
    >
      Submit
    </v-btn>
  </v-form>
</template>

<script>
  export default {
    props: ['search'],
    data () {
      return {
        valid: false,
        fieldRules: [
          v => v.length > 0 || 'This field is required'
        ],
        name: '',
        items: [],
        data: {
          should: [],
          must_not: []
        }
      }
    },
    methods: {
      async submit () {
        setTimeout(async () => {
          if (!this.$refs.form.validate()) {
            return
          }
          if (typeof this.search === 'undefined') {
            const data = await this.$axios.post('/saved-search/save', {
              name: this.name,
              data: this.data
            })
            this.$store.commit('search/addSearch', data.data)
            this.$router.push({name: 'search-view', params: {id: data.data.id}})
          } else {
            const data = await this.$axios.post('/saved-search/save', {
              name: this.name,
              data: this.data,
              id: this.search.id
            })

            this.$store.commit('search/updateSearch', {
              id: this.search.id,
              data: data.data
            })
          }
        }, 100)
      },
      setSearch () {
        if (typeof this.search === 'undefined') {
          return
        }
        this.name = this.search.name
        for (let key in this.data) {
          if (typeof this.search.data[key] !== 'undefined') {
            this.data[key] = this.search.data[key]
          } else {
            this.data[key] = []
          }
        }
      }
    },
    watch: {
      search () {
        this.setSearch()
      }
    },
    mounted () {
      this.setSearch()
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/search/SearchForm.vue